import React, { Component, ErrorInfo, ReactNode } from 'react'
import { ErrorMessage } from '../error-message/ErrorMessage'
import { Mtds } from '../..'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    error: null
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  resetErrorBoundary = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorMessage
          error={this.state.error}
          actionButton={
            <Mtds.Button
              data-variant='primary'
              onClick={() => this.resetErrorBoundary()}
            >
              Prøv på nytt
            </Mtds.Button>
          }
        />
      )
    }

    return this.props.children
  }
}
